export default __webpack_public_path__ + "static/media/grocery app.fbe16e52.png";